// Components/AddRateType.jsx
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../../../api/axios";

const AddRateType = ({ open, onClose, onAdded,roomTypes }) => {

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    room_type_id: "",
    name: "",
    description: "",
    base_price: "",
    is_active: true,
  });

  useEffect(() => {
    // if (open) {
    //   loadRoomTypes();
    // }

    if (!open) {
      setForm({
        room_type_id: "",
        name: "",
        description: "",
        base_price: "",
        is_active: true,
      });
      setLoading(false);
    }
  }, [open]);

  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.room_type_id) {
      Swal.fire({ icon: "warning", title: "Select Room Type" });
      return;
    }
    if (!form.name.trim()) {
      Swal.fire({ icon: "warning", title: "Rate Type name required" });
      return;
    }

    try {
      setLoading(true);
      await api.post("/pms/rate-types", form);

      Swal.fire({
        icon: "success",
        title: "Rate Type Added",
        timer: 1200,
        showConfirmButton: false,
      });

      if (onAdded) onAdded();
      onClose();
    } catch (err) {
      console.error("Add rate type failed:", err);
      Swal.fire({
        icon: "error",
        title: "Failed to add rate type",
        text: err.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />

      <div className="modal d-block">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Add Rate Type</h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <label className="form-label">Room Type</label>
                <select
                  className="form-select mb-2"
                  value={form.room_type_id}
                  onChange={(e) =>
                    setForm({ ...form, room_type_id: e.target.value })
                  }
                  required
                >
                  <option value="">Select Room Type</option>
                  {roomTypes.map((rt) => (
                    <option key={rt.id} value={rt.id}>
                      {rt.name}
                    </option>
                  ))}
                </select>

                <label className="form-label">Rate Type Name</label>
                <input
                  className="form-control mb-2"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />

                <label className="form-label">Description</label>
                <textarea
                  className="form-control mb-2"
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />

                <label className="form-label">Base Price</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={form.base_price}
                  onChange={(e) =>
                    setForm({ ...form, base_price: e.target.value })
                  }
                />

                <div className="form-check mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={form.is_active}
                    onChange={() =>
                      setForm({ ...form, is_active: !form.is_active })
                    }
                  />
                  <label className="form-check-label">Active</label>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>

                <button className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRateType;
